import request from '@/utils/request'

export const getPackingLists = (params) => {
  return request({
    url: '/api/packing-lists',
    method: 'get',
    params
  })
}

export const getPackingList = (packingListId) => {
  return request({
    url: `/api/packing-lists/${packingListId}`,
    method: 'get'
  })
}

export const createPackingList = (data) => {
  return request({
    url: '/api/packing-lists',
    method: 'post',
    data
  })
}

export const updatePackingList = (packingListId, data) => {
  return request({
    url: `/api/packing-lists/${packingListId}`,
    method: 'patch',
    data
  })
}

export const deletePackingList = (packingListId) => {
  return request({
    url: `/api/packing-lists/${packingListId}`,
    method: 'delete'
  })
}

/** 导入本机 localStorage 旧包装单 */
export const importLocalPackingLists = (batches) => {
  return request({
    url: '/api/packing-lists/import-local',
    method: 'post',
    data: { batches },
    skipErrorToast: true,
    timeout: 120000
  })
}
